export enum EquipmentActionType {

  // Load
  LoadEquipmentLibrary                      = 'LOAD_EQUIPMENT_LIBRARY',
  LoadEquipmentLibraryCompleted             = 'LOAD_EQUIPMENT_LIBRARY_COMPLETED',
  LoadEquipmentLibraryFailed                = 'LOAD_EQUIPMENT_LIBRARY_FAILED',

  LoadEquipmentLibraryItem                  = 'LOAD_EQUIPMENT_LIBRARY_ITEM',
  LoadEquipmentLibraryItemCompleted         = 'LOAD_EQUIPMENT_LIBRARY_ITEM_COMPLETED',
  LoadEquipmentLibraryItemFailed            = 'LOAD_EQUIPMENT_LIBRARY_ITEM_FAILED',

  LoadRecommendedEquipmentLibrary           = 'LOAD_RECOMMENDED_EQUIPMENT_LIBRARY',
  LoadRecommendedEquipmentLibraryCompleted  = 'LOAD_RECOMMENDED_EQUIPMENT_LIBRARY_COMPLETED',
  LoadRecommendedEquipmentLibraryFailed     = 'LOAD_RECOMMENDED_EQUIPMENT_LIBRARY_FAILED',

  LoadWorkflowStatusTypes                   = 'LOAD_WORKFLOW_STATUS_TYPES',
  LoadWorkflowStatusTypesCompleted          = 'LOAD_WORKFLOW_STATUS_TYPES_COMPLETED',
  LoadWorkflowStatusTypesFailed             = 'LOAD_WORKFLOW_STATUS_TYPES_FAILED',

  LoadWorkAreas                             = 'LOAD_WORK_AREAS',
  LoadWorkAreasCompleted                    = 'LOAD_WORK_AREAS_COMPLETED',
  LoadWorkAreasFailed                       = 'LOAD_WORK_AREAS_FAILED',

  LoadEmployeeEquipmentWorkflows            = 'LOAD_EMPLOYEE_EQUIPMENT_WORKFLOWS',
  LoadEmployeeEquipmentWorkflowsCompleted   = 'LOAD_EMPLOYEE_EQUIPMENT_WORKFLOWS_COMPLETED',
  LoadEmployeeEquipmentWorkflowsFailed      = 'LOAD_EMPLOYEE_EQUIPMENT_WORKFLOWS_FAILED',

  // Update
  UpdateEquipmentCategory                   = 'UPDATE_EQUIPMENT_CATEGORY',
  UpdateEquipmentCategoryCompleted          = 'UPDATE_EQUIPMENT_CATEGORY_COMPLETED',
  UpdateEquipmentCategoryFailed             = 'UPDATE_EQUIPMENT_CATEGORY_FAILED',

  UpdateEquipmentLibraryItem                = 'UPDATE_EQUIPMENT_LIBRARY_ITEM',
  UpdateEquipmentLibraryItemCompleted       = 'UPDATE_EQUIPMENT_LIBRARY_ITEM_COMPLETED',
  UpdateEquipmentLibraryItemFailed          = 'UPDATE_EQUIPMENT_LIBRARY_ITEM_FAILED',

  UpdateEmployeeEquipmentItem               = 'UPDATE_EMPLOYEE_EQUIPMENT_ITEM',
  UpdateEmployeeEquipmentItemCompleted      = 'UPDATE_EMPLOYEE_EQUIPMENT_ITEM_COMPLETED',
  UpdateEmployeeEquipmentItemFailed         = 'UPDATE_EMPLOYEE_EQUIPMENT_ITEM_FAILED',

  UpdateEmployeeEquipmentWorkFlowStatus           = 'UPDATE_EMPLOYEE_EQUIPMENT_WORKFLOW_STATUS',
  UpdateEmployeeEquipmentWorkFlowStatusCompleted  = 'UPDATE_EMPLOYEE_EQUIPMENT_WORKFLOW_STATUS_COMPLETED',
  UpdateEmployeeEquipmentWorkFlowStatusFailed     = 'UPDATE_EMPLOYEE_EQUIPMENT_WORKFLOW_STATUS_FAILED',

  // Create
  CreateEquipmentCategory                   = 'CREATE_EQUIPMENT_CATEGORY',
  CreateEquipmentCategoryCompleted          = 'CREATE_EQUIPMENT_CATEGORY_COMPLETED',
  CreateEquipmentCategoryFailed             = 'CREATE_EQUIPMENT_CATEGORY_FAILED',

  CreateEquipmentLibraryItem                = 'CREATE_EQUIPMENT_LIBRARY_ITEM',
  CreateEquipmentLibraryItemCompleted       = 'CREATE_EQUIPMENT_LIBRARY_ITEM_COMPLETED',
  CreateEquipmentLibraryItemFailed          = 'CREATE_EQUIPMENT_LIBRARY_ITEM_FAILED',

  CreateEmployeeEquipmentWorkflow           = 'CREATE_EMPLOYEE_EQUIPMENT_WORKFLOW',
  CreateEmployeeEquipmentWorkflowCompleted  = 'CREATE_EMPLOYEE_EQUIPMENT_WORKFLOW_COMPLETED',
  CreateEmployeeEquipmentWorkflowFailed     = 'CREATE_EMPLOYEE_EQUIPMENT_WORKFLOW_FAILED',

  AddNewStatusToEmployeeEquipmentWorkflow           = 'ADD_NEW_STATUS_TO_EMPLOYEE_EQUIPMENT_WORKFLOW',
  AddNewStatusToEmployeeEquipmentWorkflowCompleted  = 'ADD_NEW_STATUS_TO_EMPLOYEE_EQUIPMENT_WORKFLOW_COMPLETED',
  AddNewStatusToEmployeeEquipmentWorkflowFailed     = 'ADD_NEW_STATUS_TO_EMPLOYEE_EQUIPMENT_WORKFLOW_FAILED',

  // Delete
  DeleteEquipmentLibraryCategory            = 'DELETE_EQUIPMENT_CATEGORY',
  DeleteEquipmentLibraryCategoryCompleted   = 'DELETE_EQUIPMENT_CATEGORY_COMPLETED',
  DeleteEquipmentLibraryCategoryFailed      = 'DELETE_EQUIPMENT_CATEGORY_FAILED',

  DeleteEquipmentLibraryItem                = 'DELETE_EQUIPMENT_LIBRARY_ITEM',
  DeleteEquipmentLibraryItemCompleted       = 'DELETE_EQUIPMENT_LIBRARY_ITEM_COMPLETED',
  DeleteEquipmentLibraryItemFailed          = 'DELETE_EQUIPMENT_LIBRARY_ITEM_FAILED',

  DeleteEmployeeEquipmentWorkflow           = 'DELETE_EMPLOYEE_EQUIPMENT_WORKFLOW',
  DeleteEmployeeEquipmentWorkflowCompleted  = 'DELETE_EMPLOYEE_EQUIPMENT_WORKFLOW_COMPLETED',
  DeleteEmployeeEquipmentWorkflowFailed     = 'DELETE_EMPLOYEE_EQUIPMENT_WORKFLOW_FAILED',
}
